import { atom } from 'jotai';
import { CollateralSummaryAmount, CollateralSummaryChartData, CollateralSummaryItem } from '../../types';
import { Loadable, LoadableState } from '../../utils';
import { atomWithBroadcast } from '../core';

export type CollateralSummary = {
  lastAccountList: Array<string>;
  items: Array<CollateralSummaryItem>;
  collateralSummaryAmountsByClientId: CollateralSummaryAmount;
};

export const collateralSummaryAtom = atomWithBroadcast<LoadableState<CollateralSummary>>(
  'portfolio/collateralSummary',
  Loadable.uninitialized,
);

export const focusedDataKeyAtom = atom<keyof CollateralSummaryChartData | undefined>(undefined);
